import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './styles/contact.css'

export const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_89h6k5y', 'template_4s58jtq', form.current, 'TN69SWjXWvYuzt0Cx')
      .then((result) => {
          console.log(result.text);
          form.current.reset()
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <form ref={form} onSubmit={sendEmail}  className='contact-form'>
      <div className='wp'><a href="https://wa.me/17029317367">lala</a></div>
      <div>
        <label>What your Name?</label>
        <input type="text" name="user_name" />
      </div>

      <div>
        <label>And your Email?</label>
        <input type="email" name="user_email" />
      </div>

      <div>
        <label>Tell me your Message</label>
        <textarea name="message" />
      </div>
      
      <div>
        <input type="submit" value="Send" />   
      </div>
      
    </form>
  );
};


export default Contact
